import { render, staticRenderFns } from "./PointCloud.vue?vue&type=template&id=0b287c8c&scoped=true"
import script from "./PointCloud.vue?vue&type=script&lang=js"
export * from "./PointCloud.vue?vue&type=script&lang=js"
import style0 from "./PointCloud.vue?vue&type=style&index=0&id=0b287c8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b287c8c",
  null
  
)

export default component.exports